import service from '@/utils/request'

// 获取首页轮播图列表
export const getBannerList = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, pageSize: 20, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/banner', {
    params: defaultParams
  })
}

// 获取资讯中心列表
export const getInfo = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/infos', defaultParams)
}

// 获取文档中心列表
export const getFiles = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/files', defaultParams)
}

// 获取资讯中心分类
export const getInfoType = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, pageSize: 20, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/infos-type', defaultParams)
}

// 获取文档中心分类
export const getFileType = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, pageSize: 20, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/files-type', defaultParams)
}

export const getProject = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/project', defaultParams)
}

export const getProjectType = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, pageSize: 20, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/project-type', defaultParams)
}

// 获取视频
export const getVideo = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/videos', defaultParams)
}

//集团简介
export const getFirst = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.get('/website/api/t/first', defaultParams)
}

// 友情链接
export const getLink = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.get('/website/api/t/links', defaultParams)
}

// 关于我们
export const getAbout = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.get('/website/api/t/about', defaultParams)
}

// 港航物流 产业基地 特色小镇

export const getThree = (params = {}) => {
  // 默认参数：页码1，每页20条（和你的接口返回一致）
  const defaultParams = { pageNum: 1, ...params }
  // 替换为你的实际banner接口路径（比如 /api/banner/list）
  return service.post('/website/api/t/three', defaultParams)
}